<global-header [title]="'SISTEMA DE GESTIÓN DE PROVEEDORES'"></global-header>
<router-outlet></router-outlet>
<div *ngIf="global.loaded">
  <footer-sura></footer-sura>
</div>
